export function detecIosNew() {
  const userAgent = navigator.userAgent.toLowerCase();

  // Detecta dispositivos iOS (iPhone, iPad, iPod)
  const isIOS =
    /iphone|ipad|ipod/.test(userAgent) ||
    (navigator.maxTouchPoints > 1 && /mac/.test(userAgent));

  // Detecta si está corriendo como PWA o WebView
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  return { isIOS, isStandalone };
}
